export class CustomBase {

    constructor(L, options, variables) {
        this.L = L
        this.options = options
        this.variables = variables
    }
}


export class CustomSwitchLayersControl extends CustomBase {

    buildControl() {
        let me = this

        this.L.Control.CustomSwitchLayersControl = this.L.Control.extend({
            options: me.options,

            onAdd: function () {

                var div = me.L.DomUtil.create("div", "customSwitchLayersContainer");

                div.innerHTML = `<div class='leaflet-control-layers customSwitchLayers' title='${me.variables.layerText}'></div>`;

                me.L.DomEvent.disableClickPropagation(div);
                return div;
            },

            onRemove: function () {},
        });

        return new this.L.Control.CustomSwitchLayersControl()
    }

}

export class CustomViewPointControl extends CustomBase {

    buildControl() {
        let me = this

        this.L.Control.CustomViewPointControl = this.L.Control.extend({
            options: me.options,

            initialize: function (name, options) {
                this.name = name;
                me.L.setOptions(this, options);
            },

            onAdd: function () {
                var container = me.L.DomUtil.create(
                    "div",
                    "leaflet-control leaflet-bar customViewPointControlContainer"
                );

                // container.style.margin = "0";
                // container.style.border = "0";

                container.innerHTML = `
                    <a href="#" class="customViewPointControl" title="${me.variables.title}">
                        <i class="mdi mdi-home-outline" aria-hidden="true"></i>
                    </a>
                `
                me.L.DomEvent.disableClickPropagation(container);

                return container;
            },

            onRemove: function () {},
        });

        return new this.L.Control.CustomViewPointControl()
    }

}